import { isMockServer } from './aem.util';

export class ConfigService {
  static async fetchConfig(country: any, assetUri: any, pluginName: any): Promise<MarketConfig> {
    const baseUrl = isMockServer() ? 'http://localhost:3000' : `${assetUri}/${pluginName}/latest`;
    const url = `${baseUrl}/configs/${country}.json`; // -> should be http://localhost:3000/configs/au.json on OW mock server

    return await fetch(url).then((response) => response.json());
  }
}

export type MarketConfig = {
  region: string;
  regex: string;
  digitsCap: number;
};
